let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("bm3Jf")).then(() => parcelRequire('fEJZa'));